// USERS ENDPOINT
export const GET_USERS = `/users`;
export const SIGN_UP = `/user/signup`;
export const SIGN_IN = `/user/login`;
export const UPDATE_PROFILE = `/user/profile`;
export const FORGET_PASSWORD_USER = `/user/password/forget_password`;
export const GET_A_USER = (id, token) => `/user/password/reset_password/${id}/${token}`;
export const DELETE_USER = `/user/delete`;
export const USER_RESET_PASSWORD = (id, token) => `/user/password/reset_password/${id}/${token}`;



// STORE ENDPOINT
export const GET_ONE_STORE = (storeName) => `/store/${storeName}`;
export const GET_ALL_STORES = `/stores`;
export const CREATE_STORE = `/store/create`;
export const VALIDATE_SINGLE_STORE = (email) => `store/validate/verify-user/${email}`;
export const LOGIN_STORE = `/store/login`
export const ADD_STORE_INVENTORY = (id) => `/store/${id}/add-inventory`;
export const UPDATE_ITEM_INVENTORY = (id, itemName) => `store/${id}/inventory-update/${itemName} `;
export const STORE_FORGOT_PASSWORD = `/store/password/forget_password `;
export const STORE_RESET_PASSWORD = (id, token) => `/store/password/reset_password/${id}/${token}`;
export const DELETE_STORE = `/store/delete`;

export const VERIFY_EMAIL = (token) => `/verify/${token}`

